import Axios from "@/plugins/Axios";

export class PlanosCircuitoInfantil {
  async planoCircuito(gestaoDeAulaId, etapa_id) {
    const response = await Axios().get(
      `planos-circuito-infantil/plano-circuito/${gestaoDeAulaId}/${etapa_id}`
    );
    return response.data;
  }

  async createOrUpdate(plano) {
    const response = await Axios().post(`planos-circuito-infantil/criar-plano-circuito`, {
      plano,
    });
    return response.data;
  }

  async baixarDocumentoPlanoCircuitoInfantil(gestaoDeAulaId, etapa_id) {
    const response = await Axios()
      .get(`planos-circuito-infantil/baixar-documento-circuito/${gestaoDeAulaId}/${etapa_id}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `plano_bimestral_${gestaoDeAulaId}.pdf`;
        link.click();
      });
    return response;
  }
}

export default new PlanosCircuitoInfantil();
